import { AuthContext } from '../contexts/AuthContext';
import { useContext } from 'react';

/**
 * Custom hook to access the auth context
 * @returns {import('../contexts/AuthContext').AuthContextType} The auth context value
 * @throws {Error} If used outside of AuthContextProvider
 */
export function useAuthContext() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error(
      'useAuthContext must be used within an AuthContextProvider'
    );
  }

  return context;
}
